<template>
    <!-- we need to wait until region has bee loaded to display the app -->
    <div
        v-show="region"
        id="app"
        class="relative d-flex flex-column"
        :class="{
            'blue-glow': !$route.meta.hideNavigationGlow
        }"
    >
        <navigation
            v-if="
                !$route.meta.hideNavigation &&
                    !$route.meta.legacy &&
                    !authenticatedUser
            "
        ></navigation>
        <navigation-legacy
            v-else-if="
                !$route.meta.hideNavigation &&
                    (!$route.meta.legacy || authenticatedUser)
            "
        ></navigation-legacy>

        <router-view :class="{ 'flex-grow': true }" />

        <foot v-if="!$route.meta.hideFooter"></foot>
        <footer-legacy
            v-else-if="!$route.meta.hideFooter && $route.meta.legacy"
        ></footer-legacy>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Navigation from "./components/Navigation";
import Foot from "./components/Foot";
import NavigationLegacy from "./components/NavigationLegacy.vue";
import FooterLegacy from "./components/FootLegacy.vue";

export default {
    name: "app",

    components: { FooterLegacy, NavigationLegacy, Navigation, Foot },

    created() {
        window.addEventListener("load", () => {
            document.body.style.display = "none";
            // trigger reflow
            document.body.offsetHeight;
            document.body.style.display = "";
        });
        this.$store.dispatch("FETCH_CONFIG");
    },

    computed: {
        ...mapState({
            region: state => state.region
        }),
        ...mapState(["authenticatedUser"])
    },

    watch: {
        region(region) {
            let currentRoute = this.$route;
            let countryCode = region.data.code;

            if (
                region.status == "false" &&
                currentRoute.name != "region-lock" &&
                !currentRoute.meta.unlock
            ) {
                this.$router.push({ name: "region-lock" });
            } else if (
                !currentRoute.params.country ||
                currentRoute.params.country != countryCode
            ) {
                currentRoute.params.country = countryCode;

                this.$router.push(currentRoute);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.blue-glow:before {
    content: "";
    background-image: url("~@/assets/img/2020/navigation_bg.png");
    background-size: 100% 100px;
    background-position: top center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    z-index: 2;
    pointer-events: none;
}
</style>
